import React, { useEffect, useState } from "react";
import {
  HomeOutlined,
  SearchOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import { Layout, Menu, Dropdown, Badge, Tooltip, Breadcrumb } from "antd";
import { Images } from "../Controller";
import { Menuitems } from "./Menuitems";
import { persistor } from "../Store/Store";
import { RxDashboard } from "react-icons/rx";
import { IoIosArrowDown } from "react-icons/io";
import {
  GetDashboardData,
  GetWalletBalance,
  MemberProfile,
  UserLogout,
  getMemberServices,
} from "../ApiServices/Apifun";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { BsArrowLeft, BsArrowRight, BsBell } from "react-icons/bs";
import { AiOutlineWallet } from "react-icons/ai";
import NotificationDrawer from "./NotificationDrawer";
import { ThemeColor } from "../Theme/theme";
import { CiWallet } from "react-icons/ci";
import {
  clearAllRedux,
  setMemberService,
  setProfile,
  setWalletBal,
  setselectedTab,
} from "../Store/B2bslice";
import { dispatchtoast, trimString } from "../Utils";
import Marquee from "react-fast-marquee";
import { BiWallet } from "react-icons/bi";
import DashboardCommon from "../Views/Main/Dashboard/DashboardCommon";
const { Header, Sider, Content } = Layout;
const ProjectLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [windowwidth, setwindowwidth] = useState(window.innerWidth);
  const [showDefault, setShowDefault] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [news, setNews] = useState([]);
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const walletBalance = useSelector((state) => state.B2B.walletBal);
  const heading = useSelector((state) => state.B2B.heading);
  const subHeading = useSelector((state) => state.B2B.subHeading);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const selectedTab = useSelector((state) => state.B2B.selectedTab);
  useEffect(() => {
    const handleResize = () => {
      setwindowwidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    // setselectedTab(getLocalStorageItem("selectedTab"));
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {}, [selectedTab]);
  useEffect(() => {
    if (windowwidth > 1000) {
      setCollapsed(false);
      setShowDefault(true);
    } else {
      setCollapsed(true);
      setShowDefault(false);
    }
  }, [windowwidth]);

  const handleLogout = () => {
    UserLogout()
      .then((res) => {
        persistor.purge(); // This clears the persisted state
        dispatch(clearAllRedux());
        localStorage.clear();
        navigate("/education_login");
      })
      .catch((err) => console.log(err));
  };
  const items = [
    // {
    //   key: "1",
    //   label: (
    //     <div className="w-48">
    //       <div className="text-sm flex justify-start items-center">
    //         <AiOutlineWallet size={20} className="mr-3 text-sm text-rgbaprimary7" />
    //         <p> Wallet Balance</p>
    //       </div>
    //       <p className="font-bold text-[16px] mb-4 text-rgbaprimary7">Rs. {walletBalance}</p>
    //       <hr />
    //     </div>
    //   ),
    // },
    {
      key: "2",
      label: (
        <>
          <p
            onClick={() => navigate("/personal-info")}
            className="font-medium mb-4 text-rgbaprimary7"
          >
            View Profile
          </p>
          <hr />
        </>
      ),
    },
    {
      key: "3",
      label: (
        <p onClick={handleLogout} className="font-medium text-rgbaprimary7">
          Sign Out
        </p>
        //        <Popconfirm
        //    title="Logout"
        //    icon={<QuestionCircleOutlined />}
        //    description="Are you sure to logout?"
        //    onConfirm={()=>{}}
        //    onCancel={()=>{}}
        //    cancelButtonProps={{style:{color:"black"}}}
        //    okButtonProps={{style:{color:"white",background:"red"}}}
        //    okText="Yes"
        //    cancelText="No"
        //  >

        //       </Popconfirm>
      ),
    },
  ];
  const getNews = () => {
    GetDashboardData()
      .then((res) => {
        setNews(res.news);
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    getNews();
    MemberProfile()
      .then((res) => {
        if (res.status) {
          dispatch(setProfile(res.data.profile));
        } else {
          dispatchtoast("Unable to fetch profile detail", true);
        }
      })
      .catch((err) => console.log(err, "errr"));
    GetWalletBalance()
      .then((res) => {
        if (res.status) {
          dispatch(setWalletBal(res.balance));
        }
      })
      .catch((err) => console.log(err));
    getMemberServices()
      .then((res) => {
        if (res.status) {
          dispatch(setMemberService(res.services));
        }
      })
      .catch((err) => console.log(err));
  }, [selectedTab]);
  return (
    <>
      <Layout hasSider className="min-h-screen sidebar">
        <Sider
          style={{
            position: "fixed",
            marginBottom: "20px",
            overflowY: "scroll",
            height: "100vh",
          }}
          trigger={null}
          collapsible
          className="my-10"
          collapsed={collapsed}
        >
          <div className="demo-logo-vertical flex justify-around items-center my-5">
            {!collapsed ? (
              <>
                <div className="flex gap-4 justify-start items-center">
                  {" "}
                  <img
                    src={Images.WebsiteLogo}
                    className="h-14 w-[90%] ml-5 rounded-md"
                    alt="Weblogo"
                  />
                </div>
                <RxDashboard
                  className="h-7 w-7 text-rgbaprimary7 cursor-pointer"
                  onClick={() => setCollapsed(!collapsed)}
                />
                {/* <img
                  onClick={() => setCollapsed(!collapsed)}
                  className="cursor-pointer"
                  src={Images.hamburger}
                  alt="logo"
                  width={30}
                  height={30}
                /> */}
              </>
            ) : (
              <img
                src={Images.WebsiteSmallLogo}
                alt="WeblogoSmall"
                className="h-6 w-10"
              />
            )}
          </div>
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={["1"]}
            selectedKeys={[selectedTab]}
            items={Menuitems()}
          />
        </Sider>
        <Layout className="w-full">
          <Header
            style={{
              marginLeft: collapsed ? 75 : 230,
              // background:"linear-gradient(169deg, rgb(245, 14, 14) 0%, rgb(255 255 255) 0%, rgb(33, 111, 242) 100%, rgb(227, 9, 9) 100%)"
            }}
            className=" bg-white mt-4 flex justify-between items-center h-20"
          >
            <div className=" flex flex-wrap justify-start gap-x-3 mx-4  items-center">
              {collapsed ? (
                <p>
                  {" "}
                  <BsArrowRight
                    size={30}
                    onClick={() => setCollapsed(!collapsed)}
                    className="text-primary cursor-pointer"
                  />
                </p>
              ) : (
                ""
              )}
            </div>
            <div className=" flex flex-wrap justify-start gap-x-4 mx-4  items-center">
              {/* <div className="rounded-md  flex items-center">
                <CiWallet className="h-7 w-7 text-rgbaprimary7 font-normal" />
                <div className="outline-none border-none px-2 text-xs  py-2 rounded-md">
                  <p className=" font-bold text-base text-rgbaprimary7">
                    ₹ {walletBalance}
                  </p>
                  <p className=" font-semibold text-rgbaprimary7">
                    Available Balance
                  </p>
                </div>
              </div> */}

              <Dropdown
                className="dropdownMenu "
                menu={{ items }}
                trigger={["click"]}
              >
                <div className="md:flex sm:flex justify-around hidden  items-center w-36 cursor-pointer hover:bg-white h-11 rounded-full bg-white">
                  <div className="bg-rgbaprimary8 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm">
                    {(profiledetail?.first_name?.[0] || "").toUpperCase()}
                    {(profiledetail?.last_name?.[0] || "").toUpperCase()}
                  </div>

                  <div className="leading-5">
                    <p className="text-rgbaprimary7 font-bold">
                      <span className="capitalize">
                        {trimString(profiledetail.first_name, 6)}{" "}
                        {trimString(profiledetail.last_name, 6)}
                      </span>
                    </p>
                  </div>
                  <IoIosArrowDown />
                </div>
              </Dropdown>
            </div>
          </Header>
          <Content
            className={`bg-bsgray100 h-full p-3 ${
              collapsed ? "ml-[75px]" : "ml-[230px]"
            }`}
          >
            {news?.length !== 0 && (
              <div className="bg-primary rounded-sm w-full ">
                <Marquee pauseOnHover={true} speed={50}>
                  <p>&nbsp; &nbsp;</p>
                  {news?.map((i, index) => {
                    return (
                      <p
                        key={0}
                        className="py-1  rounded-md text-white  text-[17px]"
                      >
                        &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{index + 1}.{" "}
                        <span className="capitalize font-bold">{i.title}</span>:{" "}
                        <span className="">{i.description}</span>
                      </p>
                    );
                  })}
                </Marquee>
              </div>
            )}

            {/* <DashboardCommon /> */}
            {children}
          </Content>
        </Layout>
      </Layout>
      {openDrawer && (
        <NotificationDrawer setopen={setOpenDrawer} open={openDrawer} />
      )}
    </>
  );
};

export default ProjectLayout;
